export default __webpack_public_path__ + "b2f9b2da8f76e829b612db89416de5e2.svg";